import axios from 'axios';

export function isRemoteImageUrl(url) {
  return /^https?:\/\//i.test(String(url || '').trim());
}

export function isDataImageUrl(url) {
  return String(url || '').trim().startsWith('data:image/');
}

export async function localizeImageUrl(url, getAuthHeaders, postFn) {
  const trimmed = String(url || '').trim();
  if (!trimmed) return '';
  if (isDataImageUrl(trimmed)) return trimmed;
  if (!isRemoteImageUrl(trimmed)) {
    throw new Error('La URL debe comenzar con http:// o https://');
  }
  const headers = getAuthHeaders?.() || {};
  const post = postFn || ((body, config) => axios.post('/api/chart-builder/localize-image', body, config));
  const res = await post({ url: trimmed }, { headers });
  if (!res.data?.success || !res.data?.dataUrl) {
    throw new Error(res.data?.error || 'No se pudo guardar la imagen localmente');
  }
  return res.data.dataUrl;
}
